import React from "react";
import ProductItem from "./ProductItem.jsx";

function ProductGrid({ products }) {
  return (
    <div className="px-4 md:px-32 py-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {products.map((product) => {
          // numeric ID from Shopify GID (e.g. "gid://shopify/Product/12345")
          const numericId = String(product.id || "")
            .split("/")
            .pop();

          // Handle for SEO URLs (if present in the GraphQL response)
          const handle = product.handle;

          // Images can come back as edges or already flattened, and with `url` or `src`
          const firstImageNode =
            product.images?.edges?.[0]?.node ||
            product.images?.[0] ||
            null;

          const imageSrc =
            firstImageNode?.url ||
            firstImageNode?.src ||
            "";

          return (
            <ProductItem
              key={product.id}
              product={{
                id: numericId,          // numeric product ID
                fullId: product.id,     // full GID (unused but harmless)
                handle,                 // Shopify handle for SEO URL
                imageSrc,
                title: product.title,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ProductGrid;
